import React, { useEffect, useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Divider,
  message,
  Row,
  Spin,
  Modal,
} from "antd";
import {
  getListGiftExchangeForCustomerActive,
  GiftExchangeForCustomersApi,
} from "../../../api/giftExchange/giftExchange";
import {
  DatabaseOutlined,
  GiftFilled,
  RadarChartOutlined,
} from "@ant-design/icons";
import { store } from "../../../redux/configStore";
import { setCurrentPage } from "../../../redux/giftExchange/giftExchangeForCusActive";
import GiftExchangeModal from "./GiftExchangeModal";
import BrandedPageLayout from "../../../components/Dashboard/BrandedPageLayout";

const GiftExchangeForCustomers = () => {
  const dispatch = useDispatch();

  const {
    listGiftExchangeForCustomerActive = [],
    isLoadGiftExchangeForCustomerActive,
    currentPage,
    pageSize,
    totalRecords,
  } = useSelector(
    (state) => state.persistedReducer.giftExchangeForCusActiveSlice
  );

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedGift, setSelectedGift] = useState();
  const [isLoadCreate, setIsLoadCreate] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [loadFirstItem, setLoadFirstItem] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);

  const fetchGiftExchanges = async (page) => {
    try {
      await dispatch(
        getListGiftExchangeForCustomerActive({
          currentPage: page,
          pageSize,
          type: activeCategory,
        })
      );
    } catch (err) {
      console.error("Lỗi khi tải thông báo:", err);
    }
  };

  useEffect(() => {
    fetchGiftExchanges(1);
  }, [activeCategory]);

  useEffect(() => {
    setHasMore(listGiftExchangeForCustomerActive.length < totalRecords);
  }, [listGiftExchangeForCustomerActive.length]);

  const handleLoadMore = () => {
    setLoadFirstItem(false);
    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);
    fetchGiftExchanges(nextPage);
  };

  // Hiển thị modal
  const handleOpenModal = (gift) => {
    setSelectedGift(gift);
    setIsModalVisible(true);
  };

  // Đóng modal
  const handleCloseModal = () => {
    setIsModalVisible(false);
    setSelectedGift(null);
  };

  const handleGiftExchange = async (e) => {
    if (!selectedGift) return;
    const payload = {
      gift_exchange_id: selectedGift.id,
      other: e,
    };

    setIsLoadCreate(true);
    try {
      const response = await store.dispatch(
        GiftExchangeForCustomersApi(payload)
      );
      if (GiftExchangeForCustomersApi.fulfilled.match(response)) {
        if (response.payload.data.original) {
          message.error(response.payload.data.original.message);
        } else {
          message.success("Đổi quà thành công");
          handleCloseModal();
          fetchGiftExchanges();
        }
      } else if (GiftExchangeForCustomersApi.rejected.match(response)) {
        handleErrors(response);
      }
    } catch (error) {
      message.error("Đã xảy ra lỗi!");
    } finally {
      setIsLoadCreate(false);
    }
  };

  const handleErrors = (response) => {
    if (response.payload.errors) {
      Object.keys(response.payload.errors).forEach((field) => {
        const errorMessages = response.payload.errors[field];
        errorMessages.forEach((errorMessage) => {
          message.error(errorMessage);
        });
      });
    } else if (response.payload.error) {
      message.error(response.payload.error);
    }
    if (response.payload.message) {
      message.error(response.payload.message);
    }
  };

  const handleCategorySelect = (type) => {
    setActiveCategory(type);
    dispatch(setCurrentPage(1));
  };

  const categories = [
    {
      keyName: null,
      title: "Tất cả",
      description: "Quà tặng",
      icon: (
        <RadarChartOutlined style={{ fontSize: "40px", color: "#d0021b" }} />
      ),
    },
    {
      keyName: "PRODUCT",
      title: "Vật phẩm",
      description: "Quà tặng vật phẩm",
      icon: <GiftFilled style={{ fontSize: "40px", color: "#d0021b" }} />,
    },
    {
      keyName: "DATA",
      title: "Data",
      description: "Quà tặng dữ liệu mạng",
      icon: <DatabaseOutlined style={{ fontSize: "40px", color: "#d0021b" }} />,
    },
  ];

  return (
    <BrandedPageLayout
      title="Đổi quà & Ưu đãi"
      subtitle="Sử dụng điểm tích lũy của bạn để đổi lấy những phần quà hấp dẫn và ưu đãi đặc quyền."
      breadcrumbItems={[{ title: 'Chương trình', path: '/point-promotion' }, { title: 'Đổi quà' }]}
    >

          <Row gutter={[16, 16]} justify="center">
            {categories.map((category, index) => (
              <Col xs={24} sm={12} md={8} lg={4} key={index}>
                <Card
                  hoverable
                  onClick={() => handleCategorySelect(category.keyName)}
                  className={`gift-category`}
                  style={{
                    border:
                      activeCategory === category.keyName
                        ? "2px solid #d0021b"
                        : "1px solid #ddd",
                    borderRadius: "10px",
                    textAlign: "center",
                    padding: "10px",
                    backgroundColor:
                      activeCategory === category.keyName
                        ? "#ffe5e5"
                        : "#f9f9f9",
                    boxShadow:
                      activeCategory === category.keyName
                        ? "0px 4px 6px rgba(0,0,0,0.2)"
                        : "none",
                    cursor: "pointer",
                  }}
                >
                  <div>{category.icon}</div>
                  <h3
                    style={{
                      color:
                        activeCategory === category.keyName
                          ? "#d0021b"
                          : "#000",
                    }}
                  >
                    {category.title}
                  </h3>
                  <p>{category.description}</p>
                </Card>
              </Col>
            ))}
          </Row>

          <div
            style={{
              width: "100%",
              borderBottom: "2px solid #d0021b",
              marginBottom: "20px",
              position: "relative",
              marginTop: "20px",
            }}
          ></div>

          {isLoadGiftExchangeForCustomerActive && loadFirstItem ? (
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <Spin size="large" />
            </div>
          ) : listGiftExchangeForCustomerActive.length === 0 ? (
            <div
              style={{
                textAlign: "center",
                marginTop: "20px",
                color: "#d0021b",
              }}
            >
              Không có quà tặng nào để hiển thị.
            </div>
          ) : (
            <>
              <Row gutter={[16, 16]}>
                {listGiftExchangeForCustomerActive.map((item) => (
                  <Col xs={24} sm={12} md={8} lg={6} key={item.id}>
                    <Card
                      hoverable
                      title={item?.name}
                      bordered={false}
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: "10px",
                        textAlign: "center",
                        backgroundColor: "#f9f9f9",
                      }}
                    >
                      <p>
                        Loại quà tặng:{" "}
                        {item?.type === "PRODUCT"
                          ? "VẬT PHẨM"
                          : `DATA - Nhà mạng: ${
                              {
                                VIETTEL: "Viettel",
                                VMS: "Mobifone",
                                GPC: "Vinaphone",
                              }[item?.items[0]?.telco] || "Không xác định"
                            }`}
                      </p>

                      <p>Số điểm cần đổi: {item?.point} điểm</p>
                      <p>
                        {item?.unlimited === 1
                          ? "Có giới hạn"
                          : "Không giới hạn"}
                      </p>
                      <Button
                        type="primary"
                        style={{ marginTop: "10px" }}
                        onClick={() => handleOpenModal(item)}
                      >
                        Đổi quà
                      </Button>
                    </Card>
                  </Col>
                ))}
              </Row>
              {isLoadGiftExchangeForCustomerActive && !loadFirstItem && (
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                  <Spin size="large" />
                </div>
              )}

              {hasMore && !loadingMore && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    onClick={handleLoadMore}
                    type="link"
                    style={{
                      marginTop: "10px",
                      color: "#0288D1",
                      textDecoration: "underline",
                    }}
                  >
                    Xem thêm
                  </Button>
                </div>
              )}
            </>
          )}

          {selectedGift && (
            <GiftExchangeModal
              visible={isModalVisible}
              gift={selectedGift}
              onClose={handleCloseModal}
              onConfirm={handleGiftExchange}
              isLoading={isLoadCreate}
            />
          )}

          {/* Modal xác nhận */}
          {/* {selectedGift && (
        <Modal
          title="Xác nhận đổi quà"
          visible={isModalVisible}
          onOk={handleGiftExchange}
          onCancel={handleCloseModal}
          okText="Đổi quà"
          cancelText="Hủy"
          loading={isLoadCreate}
        >
          <p>
            <strong>Tên quà tặng:</strong> {selectedGift?.name}
          </p>
          <p>
            <strong>Loại quà tặng:</strong>{" "}
            {selectedGift?.type === "PRODUCT" ? "VẬT PHẨM" : "DATA"}
          </p>
          <p>
            <strong>Số điểm cần đổi:</strong> {selectedGift?.point} điểm
          </p>
          <p>
            <strong>Trạng thái:</strong>{" "}
            {selectedGift?.unlimited === 1 ? "Có giới hạn" : "Không giới hạn"}
          </p>
        </Modal>
      )} */}
    </BrandedPageLayout>
  );
};

export default GiftExchangeForCustomers;
